<!--
Author: TangChen
Date: 2018-09-19
Desc: 协议内容
-->
<template>
    <div class="comp-crs-info comp">
        <el-row class="taxes-box two-cols-form ">
            <el-form
                ref="taxesInfo"
                :model="taxesInfo"
                :rules="rules"
                label-width="160px"
                class="acct-form"
                size="small"
                v-on:submit.native.prevent
            >
                <el-col :span="24" class="mes-col">
                    <el-col :span="12">
                        <el-form-item label="出生日期：" class="form-text">
                            <div class="text-con">
                                {{ $util.fmtDate(taxesInfo.investorsbirthday) }}
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="税收居民身份：" class="required" prop="taxestype">
                            <el-select
                                v-model="taxesInfo.taxestype"
                                filterable
                                placeholder="请选择税收居民身份"
                                :disabled="oldTax!==''"
                            >
                                <el-option
                                    v-for="item in taxestypes"
                                    :key="item.subitem"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="taxe" :span="12">
                        <el-form-item label="姓（英文或拼音）：" prop="custfamilyname" class="required">
                            <el-input
                                v-model="taxesInfo.custfamilyname"
                                placeholder="请输入姓"
                                :maxlength="32"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col v-if="taxe" :span="12">
                        <el-form-item label="名（英文或拼音）：" prop="custfirstname" class="required">
                            <el-input
                                v-model="taxesInfo.custfirstname"
                                placeholder="请输入名"
                                :maxlength="32"
                            />
                        </el-form-item>
                    </el-col>
                </el-col>
                <el-col v-if="taxe" :span="24" class="mes-col">
                    <el-col :span="24" class="cut-off-line">
                        <span>现居地</span>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="国家/地区：" prop="currentcountry" class="required">
                            <el-select v-model="taxesInfo.currentcountry" filterable placeholder="请选择现居地国家">
                                <el-option
                                    v-for="item in countrys"
                                    :key="item.subitem"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item v-if="isChina" label="省份：" prop="currentprovince" class="required">
                            <el-select v-model="taxesInfo.currentprovince" filterable placeholder="请选择现居地省份">
                                <el-option
                                    v-for="item in provinces"
                                    :key="item.subitem"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item v-if="isChina&&(taxesInfo.currentprovince!=='710000'&&taxesInfo.currentprovince!=='810000'&&taxesInfo.currentprovince!=='820000')&&taxesInfo.currentprovince" label="城市：" prop="currentcity" class="required">
                            <el-select v-model="taxesInfo.currentcity" filterable placeholder="请选择现居城市">
                                <el-option
                                    v-for="item in currentcity"
                                    :key="item.cityid"
                                    :value="item.cityid"
                                    :label="item.cityname"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item v-if="isChina&&(taxesInfo.currentprovince!=='710000'&&taxesInfo.currentprovince!=='810000'&&taxesInfo.currentprovince!=='820000')&&taxesInfo.currentcity&&taxesInfo.currentprovince" label="县：" prop="county" class="required">
                            <el-select v-model="taxesInfo.county" filterable placeholder="请选择现居地县">
                                <el-option
                                    v-for="item in county"
                                    :key="item.countyid"
                                    :label="item.countyname"
                                    :value="item.countyid"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="地址：" prop="address" :class="{'required':isChina}">
                            <el-input
                                v-model="taxesInfo.address"
                                placeholder="请输入现居地地址"
                                :maxlength="32"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="邮编：" prop="crspostcode" class="required">
                            <el-input
                                v-model="taxesInfo.crspostcode"
                                placeholder="请输入现居地邮编"
                                :maxlength="6"
                            />
                        </el-form-item>
                    </el-col>
                </el-col>
                <el-col v-if="taxe" :span="24" class="mes-col bg">
                    <el-col :span="24" class="cut-off-line">
                        <span>现居地（英文或拼音）</span>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="国家/地区：" prop="engcurrentcountry" class="required">
                            <el-select v-model="taxesInfo.engcurrentcountry" filterable placeholder="请选择现居地国家（英文或拼音）">
                                <el-option
                                    v-for="item in enCountrys"
                                    :key="item.subitem"
                                    :label="item.subitem + '('+item.subitemname+')'"
                                    :value="item.subitem"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="省份：" prop="engcurrentprovince" class="required">
                            <el-input
                                v-model="taxesInfo.engcurrentprovince"
                                placeholder="请输入现居地省份（英文或拼音）"
                                :maxlength="64"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="城市：" prop="engcurrentcity" class="required">
                            <el-input
                                v-model="taxesInfo.engcurrentcity"
                                placeholder="请输入现居地城市（英文或拼音）"
                                :maxlength="64"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="地址：" prop="engaddress" class="required">
                            <el-input
                                v-model="taxesInfo.engaddress"
                                placeholder="请输入现居地地址（英文或拼音）"
                                :maxlength="64"
                            />
                        </el-form-item>
                    </el-col>
                </el-col>
                <el-col v-if="taxe" :span="24" class="mes-col">
                    <el-col :span="24" class="cut-off-line">
                        <span>出生地</span>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="国家/地区：" prop="birthcountry" class="required">
                            <el-select v-model="taxesInfo.birthcountry" filterable placeholder="请选择出生地国家">
                                <el-option
                                    v-for="item in countrys"
                                    :key="item.subitem"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="省份：" prop="birthprovince">
                            <el-input
                                v-model="taxesInfo.birthprovince"
                                placeholder="请输入出生地省份"
                                :maxlength="16"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="城市：" prop="birthcity">
                            <el-input
                                v-model="taxesInfo.birthcity"
                                placeholder="请输入出生地城市"
                                :maxlength="16"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="地址：" prop="birthplace">
                            <el-input
                                v-model="taxesInfo.birthplace"
                                placeholder="请输入出生地地址"
                                :maxlength="32"
                            />
                        </el-form-item>
                    </el-col>
                </el-col>
                <el-col v-if="taxe" :span="24" class="mes-col bg">
                    <el-col :span="24" class="cut-off-line">
                        <span>出生地（英文或拼音）</span>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="国家/地区：" prop="engbirthcountry" class="required">
                            <el-select v-model="taxesInfo.engbirthcountry" filterable placeholder="请选择出生地国家（英文或拼音）">
                                <el-option
                                    v-for="item in enCountrys"
                                    :key="item.subitem"
                                    :label="item.subitem + '('+item.subitemname+')'"
                                    :value="item.subitem"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="省份：" prop="engbirthprovince" class="required">
                            <el-input
                                v-model="taxesInfo.engbirthprovince"
                                placeholder="请输入出生地省份（英文或拼音）"
                                :maxlength="64"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="城市：" prop="engbirthcity" class="required">
                            <el-input
                                v-model="taxesInfo.engbirthcity"
                                placeholder="请输入出生地城市（英文或拼音）"
                                :maxlength="64"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="地址：" prop="engbirthplace" class="required">
                            <el-input
                                v-model="taxesInfo.engbirthplace"
                                placeholder="请输入出生地地址（英文或拼音）"
                                :maxlength="64"
                            />
                        </el-form-item>
                    </el-col>
                </el-col>
                <el-col v-if="taxe" :span="24" class="mes-col last">
                    <el-col :span="12">
                        <el-form-item label="注册国家/地区：" prop="regregioncode">
                            <el-select v-model="taxesInfo.regregioncode" filterable placeholder="请选择注册国家">
                                <el-option
                                    v-for="item in countrys"
                                    :key="item.subitem"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="注册地址：" prop="regadress">
                            <el-input
                                v-model="taxesInfo.regadress"
                                placeholder="请输入注册地址"
                                :maxlength="32"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="税收居民国家/地区：" prop="taxesplace" class="required">
                            <el-select v-model="taxesInfo.taxesplace" filterable placeholder="请选择税收居民国家/地区">
                                <el-option
                                    v-for="item in speCountrys"
                                    :key="item.subitem"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="有无纳税人识别号：" prop="tHaveTaxID" class="required">
                            <el-select v-model="taxesInfo.tHaveTaxID" filterable placeholder="请选择有无居民国家/地区纳税人识别号">
                                <el-option
                                    v-for="item in tHaveTaxIDs"
                                    :key="item.val"
                                    :label="item.text"
                                    :value="item.val"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item v-if="taxesInfo.tHaveTaxID==='1'" label="纳税人识别号：" prop="taxesno" class="required">
                            <el-input
                                v-model="taxesInfo.taxesno"
                                placeholder="请输入居民国家/地区纳税人识别号"
                                :maxlength="100"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item v-if="taxesInfo.tHaveTaxID==='0'" label="不能提供的原因：" prop="notaxesreason" class="required">
                            <el-select v-model="taxesInfo.notaxesreason" filterable placeholder="请选择不能提供识别号的原因">
                                <el-option
                                    v-for="item in notaxesreasons"
                                    :key="item.subitem"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item v-if="taxesInfo.tHaveTaxID==='0' && taxesInfo.notaxesreason==='2'" label="未能取得的原因：" prop="nogetreason" class="required">
                            <el-input
                                v-model="taxesInfo.nogetreason"
                                placeholder="请输入未能取得纳税人识别号的原因"
                                :maxlength="128"
                            />
                        </el-form-item>
                    </el-col>
                </el-col>
                <el-col v-if="isPwdCheck" :span="12">
                    <el-form-item label="交易密码：" prop="pwd" class="required">
                        <el-input
                            v-model="taxesInfo.pwd"
                            type="password"
                            placeholder="请输入交易密码"
                            :maxlength="16"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="" prop="agreement">
                        <el-checkbox-group v-model="taxesInfo.protocol" class="checkbox-list">
                            <el-checkbox label="1" name="agree">
                                本人确认上述信息的真实、准确和完整，且当这些信息发生变更时，将在30日内通知贵机构，否则本人承担由此造成的不利后果。
                            </el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                </el-col>
                <el-col :span="24" class="btn-group">
                    <el-button type="primary" class="medium" v-on:click="submitInfo('taxesInfo')">
                        确认
                    </el-button>
                    <el-button class="medium" v-on:click="$router.back()">
                        返回
                    </el-button>
                </el-col>
            </el-form>
        </el-row>
    </div>
</template>
<script>
export default {
    name: "CrsInfo",
    props: {
        fn: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            taxesInfo: {
                investorsbirthday: "",
                taxestype: "",
                custfamilyname: "",
                custfirstname: "",
                currentcountry: "",
                currentprovince: "",
                currentcity: "",
                county: "",
                address: "",
                crspostcode: "",
                engcurrentcountry: "",
                engcurrentprovince: "",
                engcurrentcity: "",
                engaddress: "",
                birthcountry: "",
                birthprovince: "",
                birthcity: "",
                birthplace: "",
                engbirthcountry: "",
                engbirthprovince: "",
                engbirthcity: "",
                engbirthplace: "",
                regregioncode: "",
                regadress: "",
                taxesplace: "",
                tHaveTaxID: "",
                taxesno: "",
                notaxesreason: "",
                nogetreason: "",
                protocol: [],
                agreement: "",
                pwd: ""
            },
            isPwdCheck: false,
            taxId: "", // 传入修改税收居民信息ID
            lock: "", // 是否是没有税收居民信息新增
            taxe: false, // 是否是中国税收居民
            isChina: false, // 是否是居住地在中国
            oldTax: "", // 原税收军民信息
            taxestypes: [],
            speCountrys: [], // 税收居民国家/地区数据字典
            countrys: [],
            enCountrys: [],
            provinces: [],
            currentcity: [],
            county: [],
            notaxesreasons: [],
            tHaveTaxIDs: [{ val: "0", text: "无" }, { val: "1", text: "有" }],
            taxestypeOld: "",
            rules: {
                taxestype: [
                    { required: true, message: "请选择税收居民身份", trigger: "change" }
                ],
                custfamilyname: [
                    { required: true, message: "请输入姓", trigger: "blur" },
                    { validator: this.$util.validateChar, trigger: "blur" }
                ],
                custfirstname: [
                    { required: true, message: "请输入名", trigger: "blur" },
                    { validator: this.$util.validateChar, trigger: "blur" }
                ],
                engcurrentprovince: [
                    { required: true, message: "请输入现居省份", trigger: "blur" },
                    { validator: this.$util.validateChar, trigger: "blur" }
                ],
                crspostcode: [
                    { required: true, message: "请输入邮政编码", trigger: "blur" },
                    { validator: this.$util.validatePostCode, trigger: "blur" }
                ],
                engcurrentcity: [
                    { required: true, message: "请输入现居城市", trigger: "blur" },
                    { validator: this.$util.validateChar, trigger: "blur" }
                ],
                engaddress: [
                    { required: true, message: "请输入现居地址", trigger: "blur" },
                    { validator: this.$util.validateChar, trigger: "blur" }
                ],
                engbirthprovince: [
                    { required: true, message: "请输入出生省份", trigger: "blur" },
                    { validator: this.$util.validateChar, trigger: "blur" }
                ],
                engbirthcity: [
                    { required: true, message: "请输入出生城市", trigger: "blur" },
                    { validator: this.$util.validateChar, trigger: "blur" }
                ],
                engbirthplace: [
                    { required: true, message: "请输入出生地址", trigger: "blur" },
                    { validator: this.$util.validateChar, trigger: "blur" }
                ],
                address: [
                    { validator: this.validateAddress, trigger: "blur" }
                ],
                nogetreason: [
                    { validator: this.$util.validateCCharacter, trigger: "blur" }
                ],
                taxesno: [
                    { validator: this.$util.validateCCharacter, trigger: "blur" }
                ],
                currentcountry: [
                    { required: true, message: "请选择现居地国家/地区", trigger: "change" }
                ],
                currentprovince: [
                    { required: true, message: "请选择现居地省份", trigger: "change" }
                ],
                agreement: [
                    { required: true, message: "请确认上述信息的真实、准确和完整", trigger: "change" }
                ],
                currentcity: [
                    { required: true, message: "请选择现居地城市", trigger: "change" }
                ],
                county: [
                    { required: true, message: "请选择现居地县", trigger: "change" }
                ],
                engcurrentcountry: [
                    { required: true, message: "请选择现居地国家（英文或拼音）", trigger: "change" }
                ],
                birthcountry: [
                    { required: true, message: "请选择出生地国家/地区", trigger: "change" }
                ],
                engbirthcountry: [
                    { required: true, message: "请选择出生地国家/地区（英文或拼音）", trigger: "change" }
                ],
                taxesplace: [
                    { required: true, message: "请选择税收居民国家/地区", trigger: "change" }
                ],
                tHaveTaxID: [
                    { required: true, message: "请选择有无居民国家/地区纳税人识别号", trigger: "change" }
                ],
                notaxesreason: [
                    { required: true, message: "请选择不能提供识别号的原因", trigger: "change" }
                ],
                pwd: [
                    { required: true, message: "请输入交易密码", trigger: "blur" }
                ]
            }
        };
    },
    watch: {
        "taxesInfo.taxestype" (val) {
            if (val !== "2" && val !== "3") {
                this.taxe = false;
            } else {
                if (this.taxesInfo.taxesplace === "CN") {
                    this.taxesInfo.taxesplace = "";
                }
                this.taxe = true;
            }
        },
        "taxesInfo.currentprovince" (val) {
            if (val !== "") {
                this.getCity(val);
            }
        },
        "taxesInfo.currentcity" (val) {
            if (val !== "") {
                this.getCounty(val);
            }
        },
        "taxesInfo.tHaveTaxID" (val) {
            if (val === "0") {
                this.taxesInfo.taxesno = "";
            } else {
                this.taxesInfo.notaxesreason = "";
                this.taxesInfo.nogetreason = "";
            }
        },
        "taxesInfo.currentcountry" (val) {
            if (val !== "CN") {
                this.isChina = false;
            } else {
                this.isChina = true;
            }
        },
        "taxesInfo.protocol" (val) {
            if (val.length > 0) {
                this.taxesInfo.agreement = val.join(",");
            } else {
                this.taxesInfo.agreement = "";
            }
        },
        "taxesInfo.notaxesreason" (val) {
            if (val !== "2") {
                this.taxesInfo.nogetreason = "";
            }
        }
    },
    created () {
        // 初始化数据字典值
        this.isPwdCheck = this.$cache.getPwdCheck("T3,T4");
        const info = this.$cache.getUser();
        this.taxesInfo.investorsbirthday = info.birthdate;
        this.taxId = this.$route.query.taxid;
        this.lock = this.$route.query.lock || "";
        this.oldTax = this.$route.query.tax || "";
        if (this.taxId) {
            this.getTaxesInfo(this.taxId);
        }
        this.taxestypes = this.$cache.getDict("120043");
        if (this.lock) {
            this.$set(this.taxesInfo, "taxestype", this.oldTax);
            this.taxestypes = this.taxestypes.filter(item => {
                return item.subitem !== "1";
            });
        } else {
            this.$set(this.taxesInfo, "taxestype", "1");
        }
        // this.countrys = this.$cache.getDict("120109");
        const _country = this.$cache.getDict("120109");
        let _y = [];
        let _z = [];
        for(let i in _country){
            if(_country[i].subitem === "CN" || _country[i].subitem === "HK" || _country[i].subitem === "MO" || _country[i].subitem === "TW"){
                if(_country[i].subitemname.indexOf("中国") === -1){
                    _country[i].subitemname = "中国" + _country[i].subitemname;
                }
                if(_country[i].subitem === "CN"){
                    _z.unshift(_country[i]);
                }else{
                    _z.push(_country[i]);
                }
                continue;
            }
            _y.push(_country[i]);
        }
        this.countrys = _z.concat(_y);
        this.speCountrys = this.countrys.filter(item => {
            return item.subitem !== "CN";
        });
        this.enCountrys = this.$cache.getDict("120134");
        this.provinces = this.$cache.getDict("190021");
        this.notaxesreasons = this.$cache.getDict("120044");
    },
    methods: {
        validateAddress (rule, value, callback) {
            if (this.isChina || value.trim() !== "") {
                this.$util.validateCCharacter(rule, value, callback);
            } else {
                callback();
            }
        },
        /* 提交表单数据，校验用户信息 */
        submitInfo (formName) {
            const _this = this;
            _this.$refs[formName].validate(valid => {
                if (valid) {
                    const way = (_this.lock || _this.taxId === "0" || _this.fn || !_this.taxId) ? "POST" : "PUT";
                    //判断是否重复修改中国税收居民身份
                    if (_this.taxestypeOld === "1" && _this.taxesInfo.taxestype === "1") {
                        _this.$message({
                            type: "warning",
                            message: "投资者已为中国税收居民，无需修改！"
                        });
                        return false;
                    }
                    if (_this.taxesInfo.taxestype === "1") {
                        _this.taxesInfo.taxesplace = "CN";
                    }
                    const _x = Object.assign({}, _this.taxesInfo);
                    delete _x.protocol;
                    _x.tradepwd = _this.$util.enc(_x.pwd);
                    delete _x.pwd;
                    _this.$util.request("acct/crs/info", _x, way).then(res => {
                        const msg = way === "PUT" ? "修改" : "新增";
                        if (res.data) {
                            const info = _this.$cache.getUser();
                            info.needfillcrs = "0";
                            _this.$store.dispatch("setInfo", info).then(() => {
                                _this.$message({
                                    type: "success",
                                    message: msg + "税收居民信息成功" + (_this.fn ? "" : "，3秒后回到安全中心"),
                                    onClose: function () {
                                        if (_this.fn) { _this.$emit("fn-back", true); } else {
                                            _this.$router.push({ name: "taxeslist" });
                                        }
                                    }
                                });
                            });
                        } else {
                            _this.$message({
                                type: "warning",
                                message: res.msg
                            });
                        }
                    });
                } else {
                    return false;
                }
            });
        },
        getTaxesInfo (id) {
            const _this = this;
            this.$util.request("acct/crs/info", { taxiesinfoid: id }).then(res => {
                for (let item in res.data[0]) {
                    res.data[0][item] = res.data[0][item].trim();
                }
                _this.taxesInfo = Object.assign({}, _this.taxesInfo, res.data[0] || {});
                if (_this.taxesInfo.taxesno) {
                    _this.taxesInfo.tHaveTaxID = "1";
                } else if (_this.taxesInfo.notaxesreason) {
                    _this.taxesInfo.tHaveTaxID = "0";
                }
                _this.taxestypeOld = _this.taxesInfo.taxestype;
            });
        },
        getCity (val) {
            const _this = this;
            this.$util.request("common/citylist", { provinceid: val }).then(res => {
                _this.currentcity = res.data;
            });
        },
        getCounty (val) {
            const _this = this;
            this.$util.request("common/countylist", { cityid: val }).then(res => {
                _this.county = res.data;
            });
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.comp-crs-info {
    .taxes-box {
        padding: 30px 30px 45px;
        .mes-col {
            margin-bottom: 10px;
            &.last {
                margin-bottom: 0;
            }
            .cut-off-line {
                margin: 30px 0 0;
                top: -30px;
                font-size: $f16;
            }
            &.bg {
                background-color: $bg5;
                .cut-off-line {
                    border-color: $border-color9;
                    span {
                        color: $color-b;
                    }
                }
            }
        }
    }
}
</style>
